define('models/strategyRetiredTargetSegment',["jQuery", "T1", "Backbone", "T1Model", "T1Collection"], function ($, T1, Backbone, T1Model, T1Collection) {
  T1.Models.StrategyRetiredTargetSegment = T1Model.extend({
    url: "retired_targeting_segments/",
    fixture: "-strategy_retired_targeting_segments"
  });
  return T1.Models.StrategyRetiredTargetSegment;
});
